// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Knowledge — 지식베이스 영역 (Figma 71:5938 외)
   사이드바·인트로 공통 스타일은 Prompt.css 재사용 (.prompt__sidebar / .prompt-intro__*)
   ======================================================================== */

/* example 텍스트 줄바꿈 보존 */
.knowledge-intro__example-pre {
  white-space: pre-wrap;
}

/* ───────── 비교 테이블 ───────── */
.knowledge-intro__vs-table {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background: var(--fg-bg-card);
  border-top: 2px solid var(--fg-text-basic);
}

.knowledge-intro__vs-row {
  display: contents;
}

.knowledge-intro__vs-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid var(--fg-line);
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
  text-align: center;
}

.knowledge-intro__vs-cell--label {
  background: #f8f8f8;
  font-weight: 500;
}

.knowledge-intro__vs-row--head .knowledge-intro__vs-cell {
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
}

.knowledge-intro__vs-cell--head-blue {
  background: var(--fg-bg-vs-blue);
}

.knowledge-intro__vs-cell--head-green {
  background: var(--fg-bg-vs-green);
}


/* ========================================================================
   KnowledgeList — 지식베이스 관리 (Figma 73:3892)
   ======================================================================== */

/* 모드 선택 카드 */
.knowledge-mode__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.knowledge-mode__card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.knowledge-mode__card:hover {
  border-color: var(--fg-button);
  box-shadow: var(--shadow-md);
}

.knowledge-mode__card--clickable {
  cursor: pointer;
}

.knowledge-mode__card--clickable:focus-visible {
  outline: none;
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.25);
}

.knowledge-mode__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.knowledge-mode__card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.knowledge-mode__card-summary {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-gray);
}

.knowledge-mode__feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.knowledge-mode__feature-list li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.knowledge-mode__feature-list svg {
  flex-shrink: 0;
  color: var(--fg-button);
}

.knowledge-mode__card-usage {
  margin: 8px 0 0;
  padding-top: 12px;
  border-top: 1px solid var(--fg-line);
  text-align: center;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.knowledge-mode__card-usage b {
  font-size: 18px;
  font-weight: 700;
  color: var(--fg-text-basic);
  margin-right: 4px;
}

/* 통계 — 실패 강조 */
.knowledge-files__stat--failed b {
  color: var(--fg-anti-red);
}

/* 선택 설정 드롭다운 */
.knowledge-files__select-action {
  position: relative;
  display: inline-block;
}

.knowledge-files__select-action .prompt-list__select-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.knowledge-files__select-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  z-index: 30;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.knowledge-files__select-menu-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-text-basic);
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.knowledge-files__select-menu-item:hover {
  background: var(--bg-hover, #f5f5f7);
}

.knowledge-files__select-menu-item--danger {
  color: var(--fg-anti-red);
}

.knowledge-files__select-menu-item--danger:hover {
  background: rgba(220, 38, 38, 0.08);
}

/* 전체 선택 — 일부 선택 상태 */
.prompt-list__bulk-toggle--indeterminate {
  background: var(--fg-side-hover);
  opacity: 0.5;
}

/* 파일 그리드 */
.knowledge-files__grid {
  display: grid;
  gap: 20px;
}

.knowledge-files__grid--grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.knowledge-files__grid--list {
  grid-template-columns: 1fr;
}

@media (max-width: 1280px) {
  .knowledge-files__grid--grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .knowledge-mode__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* 모바일 안내 — 기본 숨김, ≤720px 에서만 노출 */
.knowledge-mode__mobile-note {
  display: none;
}

/* ========================================================================
   모바일 (≤720px) — 파일 리스트 + 간편 업로드만 지원.
   고급 설정·비교 모드 진입점은 숨기고 한 줄 안내로 대체.
   레이아웃이 공유 .prompt 라 .knowledge-page 로 스코프해 프롬프트 화면 영향 차단.
   ======================================================================== */
@media (max-width: 720px) {
  /* 레이아웃: 사이드바(관리 1개뿐) 숨김, 여백 축소 */
  .knowledge-page .prompt__layout {
    margin: 0 8px;
  }

  .knowledge-page .prompt__sidebar {
    display: none;
  }

  .knowledge-page .prompt__content {
    padding: 20px 16px;
    gap: 28px;
  }

  .knowledge-page .prompt-intro__h1 {
    font-size: 22px;
    line-height: 32px;
  }

  /* 모드 선택: 1열 + 고급/비교 카드 숨김
     (minmax(0,1fr) — 1fr=minmax(auto,1fr) 이라 긴 내용이 트랙을 밀어 오버플로되는 것 방지) */
  .knowledge-page .knowledge-mode__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .knowledge-page .knowledge-mode__card--advanced,
  .knowledge-page .knowledge-mode__card--compare {
    display: none;
  }

  .knowledge-page .knowledge-mode__mobile-note {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 2px 0 0;
    font-size: 13px;
    line-height: 1.4;
    color: var(--fg-text-gray);
  }

  .knowledge-page .knowledge-mode__mobile-note svg {
    flex-shrink: 0;
    color: var(--fg-text-gray);
  }

  /* 파일 리스트: 그리드/리스트 뷰 모두 1열
     (minmax(0,1fr) 필수 — 긴 파일명(nowrap)이 트랙을 밀어내 ellipsis 대신 잘리는 문제 방지) */
  .knowledge-page .knowledge-files__grid--grid,
  .knowledge-page .knowledge-files__grid--list {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  /* 통계 행: 세로 스택 + 업로드 버튼 풀폭 */
  .knowledge-page .prompt-list__stats-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .knowledge-page .prompt-list__stats {
    flex-wrap: wrap;
    gap: 6px 8px;
  }

  /* 필터 행: 검색이 줄을 가득 채우도록, 그리드/리스트 토글은 숨김(어차피 1열) */
  .knowledge-page .prompt-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .knowledge-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  .knowledge-page .prompt-list__view-toggle {
    display: none;
  }

  /* 간편 업로드: 제목·드롭존 여백 축소 */
  .knowledge-page .knowledge-upload__title {
    font-size: 22px;
    line-height: 32px;
  }

  .knowledge-page .knowledge-upload__zone {
    padding: 28px 16px 32px;
  }
}

/* 파일 카드 */
.knowledge-files__card {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.knowledge-files__card:hover {
  border-color: var(--fg-button);
}

.knowledge-files__card--selected {
  border-color: var(--fg-side-hover);
  box-shadow: 0 0 0 1px var(--fg-side-hover);
}

.knowledge-files__card-check {
  flex-shrink: 0;
  padding-top: 2px;
}

.knowledge-files__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.knowledge-files__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.knowledge-files__name {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.knowledge-files__meta {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}

.knowledge-files__chunks {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}

/* 페이지네이션 */
.knowledge-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 24px 0 8px;
}

.knowledge-pagination__btn,
.knowledge-pagination__num {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.knowledge-pagination__btn:hover:not(:disabled),
.knowledge-pagination__num:hover {
  background: var(--fg-bg-card);
  border-color: var(--fg-button);
}

.knowledge-pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.knowledge-pagination__num--active {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}

.knowledge-pagination__num--active:hover {
  background: var(--fg-button-hover);
  color: #fff;
}

.knowledge-pagination__gap {
  padding: 0 4px;
  color: var(--fg-text-gray);
}

/* ========================================================================
   KnowledgeList — 간편 업로드 화면 (mode === 'simple') — Figma 2010:32983
   ======================================================================== */

.knowledge-upload {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 30px 0;
}

.knowledge-upload__back {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.knowledge-upload__back:hover {
  background: var(--fg-bg-card);
}

.knowledge-upload__head {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.knowledge-upload__title-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.knowledge-upload__title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic);
}

.knowledge-upload__info {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.knowledge-upload__desc {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  font-weight: 400;
}

/* 드롭존 — 흰배경+실선 border, 큰 아이콘 60px */
.knowledge-upload__zone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 40px 40px 50px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition-fast);
  outline: none;
}

.knowledge-upload__zone:hover,
.knowledge-upload__zone:focus-visible {
  border-color: var(--fg-button);
  background: #fff;
}

.knowledge-upload__zone--drag {
  border-color: var(--fg-button);
  background: #f6f3ff;
}

.knowledge-upload__zone--uploading {
  cursor: not-allowed;
  opacity: 0.85;
}

.knowledge-upload__input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.knowledge-upload__zone-icon {
  display: grid;
  place-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: 4px;
  color: var(--fg-text-basic);
}

.knowledge-upload__zone-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.knowledge-upload__zone-sub {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  font-weight: 400;
}

.knowledge-upload__zone-formats {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
}

/* 진행 리스트 */
.knowledge-upload__progress-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.knowledge-upload__progress-item {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.knowledge-upload__progress-icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  background: var(--fg-bg-card);
  border-radius: 8px;
  color: var(--fg-button);
}

.knowledge-upload__progress-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.knowledge-upload__progress-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.knowledge-upload__progress-meta {
  font-size: 12px;
  color: var(--fg-text-gray);
}

.knowledge-upload__progress-err {
  color: var(--fg-anti-red);
}

.knowledge-upload__progress-bar {
  position: relative;
  width: 100%;
  height: 4px;
  margin-top: 4px;
  background: var(--fg-bg-card);
  border-radius: 999px;
  overflow: hidden;
}

.knowledge-upload__progress-fill {
  height: 100%;
  background: var(--fg-button);
  border-radius: 999px;
  transition: width 160ms ease-out;
}

.knowledge-upload__progress-fill--ready {
  background: var(--fg-button);
}

.knowledge-upload__progress-fill--failed {
  background: var(--fg-anti-red);
}

.knowledge-upload__progress-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.knowledge-upload__progress-status--uploading {
  background: var(--fg-bg-card);
  color: var(--fg-text-gray);
}

.knowledge-upload__progress-status--ready {
  background: rgba(151, 140, 202, 0.16);
  color: var(--fg-button-hover);
}

.knowledge-upload__progress-status--failed {
  background: rgba(255, 21, 0, 0.1);
  color: var(--fg-anti-red);
}

/* ========================================================================
   AdvancedSetupView — 고급 설정 (4-step) — Figma 2010:32954
   ======================================================================== */

.kb-advanced {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 헤더 */
.kb-advanced__header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.kb-advanced__back {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-advanced__back:hover {
  background: var(--fg-bg-card);
}

.kb-advanced__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kb-advanced__title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.kb-advanced__info {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
}

/* Stepper — pill 컨테이너 + 시안 numbering — Figma 2010:32997 */
.kb-stepper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
}

.kb-stepper__row {
  display: flex;
  align-items: center;
  gap: 0;
}

.kb-stepper__step {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px 8px 8px;
  background: var(--fg-bg-stepper-inactive);
  border-radius: 50px;
  transition: var(--transition-fast);
}

.kb-stepper__step--active {
  background: var(--fg-bg-liteblue);
}

.kb-stepper__step--done {
  background: var(--fg-bg-liteblue);
}

.kb-stepper__circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 46px;
  padding: 0 12px;
  border-radius: 23px;
  background: var(--fg-numbering-bg);
  color: #fff;
  font-family: var(--font-sans);
  font-size: 20px;
  font-weight: 900;
  line-height: 26px;
  flex-shrink: 0;
}

.kb-stepper__step--active .kb-stepper__circle {
  background: var(--fg-numbering-bg-current);
  color: #fff;
}

.kb-stepper__step--done .kb-stepper__circle {
  background: var(--fg-numbering-bg-current);
  color: #fff;
}

.kb-stepper__label {
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-gray);
  white-space: nowrap;
}

.kb-stepper__step--active .kb-stepper__label {
  color: var(--fg-text-basic);
}

.kb-stepper__step--done .kb-stepper__label {
  color: var(--fg-text-basic);
}

.kb-stepper__line {
  width: 20px;
  height: 1px;
  background: var(--fg-line);
}

.kb-stepper__line--active {
  background: var(--fg-numbering-bg-current);
}

/* Step content (no extra card) */
.kb-step {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.kb-step__head {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kb-step__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.kb-step__desc {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-gray);
}

/* Step Card (legacy / preview list 등 호환용 컨테이너) */
.kb-step-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 14px;
}

.kb-step-card__head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kb-step-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-step-card__desc {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

/* Empty */
.kb-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--fg-text-gray);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.kb-empty p { margin: 0; font-size: 14px; }

/* Document grid (Step 1) — 3-col grid */
.kb-doc-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

@media (max-width: 1280px) {
  .kb-doc-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

.kb-doc-card {
  display: block;
  padding: 16px 20px;
  min-height: 80px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-doc-card:hover {
  border-color: var(--fg-button);
}

.kb-doc-card--selected {
  border-color: var(--fg-button);
  background: rgba(151, 140, 202, 0.06);
}

.kb-doc-card--disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.kb-doc-card--disabled:hover {
  border-color: var(--fg-line);
}

.kb-doc-card__info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kb-doc-card__name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kb-doc-card__meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

.kb-doc-card__meta-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: var(--fg-line);
}

/* Step 1 actions row (left + right group) */
.kb-step-actions__group {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

/* legacy doc-list (호환용 — 미사용 시 제거 가능) */
.kb-doc-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kb-doc-item {
  display: grid;
  grid-template-columns: 22px 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-doc-item:hover {
  border-color: var(--fg-button);
}

.kb-doc-item--selected {
  border-color: var(--fg-button);
  background: rgba(151, 140, 202, 0.06);
}

.kb-doc-item--disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.kb-doc-item--disabled:hover {
  border-color: var(--fg-line);
}

.kb-doc-item__info { min-width: 0; }
.kb-doc-item__name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 상태 뱃지 */
.kb-doc-badge {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.kb-doc-badge--completed,
.kb-doc-badge--ready {
  background: rgba(151, 140, 202, 0.16);
  color: var(--fg-button-hover);
}
.kb-doc-badge--uploading,
.kb-doc-badge--processing,
.kb-doc-badge--pending {
  background: rgba(255, 178, 38, 0.14);
  color: #b07700;
}
.kb-doc-badge--failed {
  background: rgba(255, 21, 0, 0.1);
  color: var(--fg-anti-red);
}

/* 빈 상태 보조 텍스트 */
.kb-empty__hint {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}
.kb-doc-item__meta {
  font-size: 12px;
  color: var(--fg-text-gray);
}

/* Radio */
.kb-radio {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  border: 1.5px solid var(--fg-line);
}
.kb-radio--selected {
  border-color: var(--fg-button);
}
.kb-radio__dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--fg-button);
}

.kb-show-more {
  align-self: flex-start;
  padding: 6px 12px;
  background: transparent;
  border: 1px dashed var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-gray);
  cursor: pointer;
}
.kb-show-more:hover {
  color: var(--fg-text-basic);
  border-color: var(--fg-button);
}

/* Option cards (Step 2/3) — 큰 풀폭 카드 */
.kb-option-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}


.kb-option-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 22px;
  min-height: 85px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-option-card:hover { border-color: var(--fg-button); }
.kb-option-card--active {
  border-color: var(--fg-button);
  background: rgba(151, 140, 202, 0.06);
  box-shadow: 0 0 0 1px var(--fg-button);
}

.kb-option-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kb-option-card__icon {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  background: var(--fg-bg-card);
  border-radius: 6px;
  color: var(--fg-button);
  flex-shrink: 0;
}

.kb-option-card__title {
  flex: 1 1;
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-option-card__badge {
  padding: 2px 10px;
  background: var(--fg-button);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  flex-shrink: 0;
}

.kb-option-card__desc {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

/* Form */
.kb-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kb-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.kb-form-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}


.kb-section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* 리랭크 토글 박스 */
.kb-toggle-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 22px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.kb-toggle-box--active {
  border-color: var(--fg-button);
  background: rgba(151, 140, 202, 0.04);
}

.kb-toggle-box__head {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.kb-toggle-box__title-group {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kb-toggle-box__title {
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-toggle-box__desc {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

/* 토글 스위치 */
.kb-switch {
  position: relative;
  display: inline-flex;
  width: 36px;
  height: 20px;
  background: var(--fg-line);
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  transition: var(--transition-fast);
  flex-shrink: 0;
}

.kb-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  transition: transform 160ms ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.kb-switch--on {
  background: var(--fg-button);
}

.kb-switch--on .kb-switch__thumb {
  transform: translateX(16px);
}

.kb-form-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
}
.kb-form-label__hint {
  margin-left: 4px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

.kb-form-hint {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}

.kb-form-input,
.kb-form-select,
.kb-form-textarea {
  width: 100%;
  padding: 9px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  outline: none;
  transition: var(--transition-fast);
}

.kb-form-input--narrow {
  max-width: 160px;
}

.kb-form-textarea {
  resize: vertical;
  min-height: 80px;
}

.kb-form-input:focus,
.kb-form-select:focus,
.kb-form-textarea:focus {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);
}

/* Slider — horizontal: label - track - value */
.kb-slider-row {
  display: grid;
  grid-template-columns: 220px 1fr 60px;
  align-items: center;
  gap: 24px;
  padding: 4px 0;
}


.kb-slider-row__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.kb-slider-row__label-text {
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-slider-row__hint {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.kb-slider-row__value {
  text-align: right;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* legacy slider container — used in existing code */
.kb-slider {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kb-slider__input {
  flex: 1 1;
  height: 4px;
  appearance: none;
  background: var(--fg-bg-card);
  border-radius: 999px;
  outline: none;
}

.kb-slider__input::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: var(--fg-button);
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
}
.kb-slider__input::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: var(--fg-button);
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
}

.kb-slider__value {
  min-width: 56px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* Buttons — Figma 2010:33033 / 33037 / 33038 (rounded 12px, Bold 16px) */
.kb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}
.kb-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.kb-btn:hover:not(:disabled) { border-color: var(--fg-button); }

.kb-btn svg {
  flex-shrink: 0;
}

/* "이전 / 취소" 등 보조 버튼 — gray solid */
.kb-btn--ghost {
  background: var(--fg-text-gray);
  border-color: var(--fg-text-gray);
  color: #fff;
}
.kb-btn--ghost:hover:not(:disabled) {
  background: #5a5a5a;
  border-color: #5a5a5a;
  color: #fff;
}

.kb-btn--outline {
  background: #fff;
  border-color: var(--fg-button);
  color: var(--fg-button);
}
.kb-btn--outline:hover:not(:disabled) {
  background: rgba(151, 140, 202, 0.08);
  border-color: var(--fg-button);
}

.kb-btn--primary {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}
.kb-btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
}

.kb-btn--sm { min-height: 36px; padding: 6px 12px; font-size: 14px; border-radius: 10px; }
.kb-btn--lg { min-height: 48px; padding: 12px 24px; font-size: 16px; }
.kb-btn--block { width: 100%; }

.kb-step-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 16px;
}

/* Preview list */
.kb-preview-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: var(--fg-bg-card);
  border-radius: 10px;
}
.kb-preview-list__item {
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}
.kb-preview-list__label {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-button);
}
.kb-preview-list__text {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
}

/* Summary section (Step 4) — section title + bordered rows */
.kb-summary-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.kb-summary-section__title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-summary-rows {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  overflow: hidden;
}

.kb-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--fg-line);
  font-size: 14px;
}

.kb-summary-row:last-child {
  border-bottom: 0;
}

.kb-summary-row > span {
  color: var(--fg-text-gray);
  font-weight: 500;
  flex-shrink: 0;
}

.kb-summary-row > b {
  color: var(--fg-text-basic);
  font-weight: 500;
  text-align: right;
  word-break: break-all;
}

/* Summary cards (legacy 호환) */
.kb-summary {
  padding: 16px 18px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.kb-summary__title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-summary__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kb-summary__list li {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.kb-summary__list span { color: var(--fg-text-gray); }
.kb-summary__list b { color: var(--fg-text-basic); font-weight: 600; }

/* ========================================================================
   CompareModeView — 비교 모드 (Figma 2010:33309)
   ======================================================================== */

.kb-cmp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 30px 0;
}

/* 페이지 헤더 */
.kb-cmp__back {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}
.kb-cmp__back:hover {
  background: var(--fg-bg-card);
}

.kb-cmp__page-title-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.kb-cmp__page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic);
}

.kb-cmp__page-info {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.kb-cmp__page-desc {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  font-weight: 400;
}

/* 모델 선택 (페이지 우측 상단) */
.kb-cmp__model-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.kb-cmp__model-select {
  min-width: 291px;
  height: 36px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
}
.kb-cmp__model-select:focus {
  outline: none;
  border-color: var(--fg-button);
}

/* 모델 트리거 버튼 (popover anchor) */
.kb-cmp__model-anchor {
  position: relative;
  display: inline-flex;
}

.kb-cmp__model-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 291px;
  height: 36px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__model-trigger:hover {
  border-color: var(--fg-button);
}

.kb-cmp__model-trigger[aria-expanded='true'] {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);
}

.kb-cmp__model-trigger-prefix {
  color: var(--fg-text-gray);
  font-weight: 400;
  flex-shrink: 0;
}

.kb-cmp__model-trigger-name {
  flex: 1 1;
  text-align: left;
  font-weight: 600;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kb-cmp__model-trigger-placeholder-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: var(--fg-bg-card);
  border-radius: 4px;
}

.kb-cmp__model-trigger > svg:last-child {
  color: var(--fg-text-gray);
  flex-shrink: 0;
}

/* ── 통합 쿼리 바 ── */
.kb-cmp__query {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 14px;
}

.kb-cmp__query-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.kb-cmp__query-meta {
  flex: 1 1;
  min-width: 0;
}

.kb-cmp__query-title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-cmp__query-desc {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

.kb-cmp__query-model {
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kb-cmp__query-input {
  width: 100%;
  padding: 12px 14px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic);
  resize: vertical;
  min-height: 80px;
  outline: none;
  transition: var(--transition-fast);
}

.kb-cmp__query-input:focus {
  background: #fff;
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);
}

.kb-cmp__query-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.kb-cmp__query-actions-left {
  display: inline-flex;
  gap: 6px;
}

/* ── 비교 인사이트 ── */
.kb-cmp__insights {
  padding: 14px 18px;
  background: linear-gradient(180deg, rgba(151, 140, 202, 0.08), rgba(151, 140, 202, 0.02));
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.kb-cmp__insights-title {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--fg-button-hover);
}

.kb-cmp__insights-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}


.kb-cmp__insight-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.kb-cmp__insight-head {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--fg-text-gray);
}

.kb-cmp__insight-head svg { color: var(--fg-button); }

.kb-cmp__insight-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-size: 13px;
  color: var(--fg-text-basic);
}

.kb-cmp__insight-val {
  font-weight: 600;
}

.kb-cmp__delta {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.kb-cmp__delta--a-better {
  background: rgba(34, 197, 94, 0.12);
  color: #137a3a;
}
.kb-cmp__delta--b-better {
  background: rgba(255, 21, 0, 0.1);
  color: var(--fg-anti-red);
}
.kb-cmp__delta--same {
  background: var(--fg-bg-card);
  color: var(--fg-text-gray);
}

/* ── 패널 그리드 ── */
.kb-cmp__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}


/* ── 패널 (Frame 484/485) ── */
.kb-cmp__panel {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 16px;
  box-shadow: 0 7px 9px 2px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.kb-cmp__panel--running {
  border-color: var(--fg-button);
  box-shadow: 0 7px 9px 2px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(151, 140, 202, 0.12);
}

/* 패널 헤더 (48px, light bg) */
.kb-cmp__panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 8px 16px;
  background: var(--fg-bg-toolbar);
}

.kb-cmp__panel-head-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* A/B 둥근 라벨 (28x28) */
.kb-cmp__panel-badge {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.kb-cmp__panel-badge--a {
  background: var(--fg-button-hover);
}

.kb-cmp__panel-badge--b {
  background: var(--fg-class-green);
}

.kb-cmp__panel-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

/* 헤더 우측 toolbar 버튼 (refresh) */
.kb-cmp__panel-refresh {
  display: grid;
  place-items: center;
  width: 34px;
  height: 32px;
  background: var(--fg-bg-litepp);
  border: 0;
  border-radius: 4px;
  color: var(--fg-button-hover);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__panel-refresh:hover {
  background: var(--fg-button);
  color: #fff;
}

/* 패널 본문 */
.kb-cmp__panel-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

/* 모드 선택 카드 3개 */
.kb-cmp__mode-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.kb-cmp__mode-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  cursor: pointer;
  text-align: center;
  transition: var(--transition-fast);
}

.kb-cmp__mode-card:hover {
  border-color: var(--fg-text-basic);
}

.kb-cmp__mode-card--active {
  background: #fff;
  border-color: var(--fg-text-basic);
  border-width: 1px;
  box-shadow: inset 0 0 0 1px var(--fg-text-basic);
}

.kb-cmp__mode-card__icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  color: var(--fg-text-gray);
}

.kb-cmp__mode-card--active .kb-cmp__mode-card__icon {
  color: var(--fg-text-basic);
}

.kb-cmp__mode-card__title {
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-gray);
}

.kb-cmp__mode-card--active .kb-cmp__mode-card__title {
  color: var(--fg-text-basic);
}

.kb-cmp__mode-card__desc {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--fg-text-gray);
}

/* 문서 선택 (full width dropdown) */
.kb-cmp__doc-select-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kb-cmp__doc-select-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.kb-cmp__doc-select {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  cursor: pointer;
}
.kb-cmp__doc-select:focus { outline: none; border-color: var(--fg-button); }

/* 모드 안내 영역 */
.kb-cmp__panel-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kb-cmp__panel-info-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.kb-cmp__panel-info-desc {
  margin: 0;
  font-size: 15px;
  line-height: 28px;
  color: var(--fg-text-basic);
}

/* B 패널 동기화 힌트 */
.kb-cmp__sync-hint {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-button);
}

/* 채팅 입력 박스 */
.kb-cmp__chat-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0 2px 3.35px rgba(0, 0, 0, 0.2);
}

.kb-cmp__chat-input__field {
  flex: 1 1;
  min-width: 0;
  height: 26px;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  outline: none;
}

.kb-cmp__chat-input__field::placeholder {
  color: var(--fg-text-gray);
}

.kb-cmp__chat-input__send {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  background: var(--fg-button);
  border: 0;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
  flex-shrink: 0;
}

.kb-cmp__chat-input__send:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.kb-cmp__chat-input__send:disabled {
  background: var(--fg-line);
  cursor: not-allowed;
}

/* 응답 박스 (AI 응답) */
.kb-cmp__response {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.kb-cmp__response-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.kb-cmp__response-head-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.kb-cmp__response-label {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}

.kb-cmp__response-model {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background: var(--fg-bg-litepp);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #000;
}

.kb-cmp__response-stats {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.kb-cmp__response-stat {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--fg-text-basic);
}

.kb-cmp__response-stat-label {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
}

.kb-cmp__response-stat-value {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

.kb-cmp__response-stat-divider {
  display: inline-block;
  width: 1px;
  height: 22px;
  background: var(--fg-line);
}

.kb-cmp__response-body {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
  word-break: break-word;
}

.kb-cmp__response-empty {
  margin: 0;
  font-size: 15px;
  color: var(--fg-text-gray);
  font-style: italic;
}

.kb-cmp__response-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--fg-text-gray);
  font-size: 14px;
}

/* legacy 비교 panel-tag (사용 안 함) */
.kb-cmp__panel-tag {
  padding: 4px 10px;
  background: var(--fg-button);
  color: #fff;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

/* 모드 세그먼트 */
.kb-cmp__seg {
  display: inline-flex;
  background: var(--fg-bg-card);
  border-radius: 8px;
  padding: 2px;
}

.kb-cmp__seg-btn {
  padding: 6px 12px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__seg-btn--active {
  background: #fff;
  color: var(--fg-text-basic);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

/* 패널 설정 영역 */
.kb-cmp__panel-config {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 문서 선택 inline trigger */
.kb-cmp__doc {
  position: relative;
}

.kb-cmp__doc-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  background: var(--fg-bg-card);
  border: 1px dashed var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__doc-trigger:hover {
  border-color: var(--fg-button);
  color: var(--fg-text-basic);
}

.kb-cmp__doc-trigger--filled {
  background: #fff;
  border-style: solid;
  border-color: var(--fg-button);
  color: var(--fg-text-basic);
}

.kb-cmp__doc-trigger > svg:first-of-type { color: var(--fg-button); flex-shrink: 0; }
.kb-cmp__doc-trigger > svg:last-of-type { margin-left: auto; flex-shrink: 0; opacity: 0.6; }

.kb-cmp__doc-text {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.kb-cmp__doc-tag {
  flex-shrink: 0;
  padding: 1px 6px;
  background: rgba(151, 140, 202, 0.16);
  color: var(--fg-button-hover);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.kb-cmp__doc-backdrop {
  position: fixed;
  inset: 0;
  z-index: 4;
}

.kb-cmp__doc-pop {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
  max-height: 320px;
  overflow: hidden;
}

.kb-cmp__doc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  max-height: 240px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kb-cmp__doc-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__doc-item:hover {
  background: var(--fg-bg-card);
}

.kb-cmp__doc-item--selected {
  background: rgba(151, 140, 202, 0.1);
}

.kb-cmp__doc-item-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kb-cmp__doc-item-meta {
  font-size: 11px;
  color: var(--fg-text-gray);
}

.kb-cmp__doc-empty {
  padding: 16px;
  text-align: center;
  font-size: 13px;
  color: var(--fg-text-gray);
}

/* 고급 옵션 토글 */
.kb-cmp__opts-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-cmp__opts-toggle:hover {
  background: var(--fg-bg-card);
}

.kb-cmp__opts-toggle--open svg:last-child {
  transform: rotate(180deg);
}

.kb-cmp__opts-toggle svg:last-child {
  transition: transform 160ms ease;
  margin-left: 0;
}

.kb-cmp__opts-summary {
  margin-left: auto;
  margin-right: 4px;
  font-size: 12px;
  color: var(--fg-text-gray);
  font-weight: 500;
}

.kb-cmp__opts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  background: var(--fg-bg-card);
  border-radius: 10px;
}

.kb-cmp__slider {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kb-cmp__slider-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}

.kb-cmp__slider-label { color: var(--fg-text-gray); }
.kb-cmp__slider-value { font-weight: 600; color: var(--fg-text-basic); }

/* 결과 영역 */
.kb-cmp__panel-result {
  flex: 1 1;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.kb-cmp__result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.kb-cmp__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-cmp__chip svg {
  color: var(--fg-button);
}

.kb-cmp__result-body {
  flex: 1 1;
  font-size: 13px;
  line-height: 21px;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-y: auto;
  max-height: 360px;
}

.kb-cmp__result-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--fg-text-gray);
}

.kb-cmp__result-empty p {
  margin: 0;
  font-size: 13px;
  font-style: italic;
}

.kb-cmp__result-loading {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--fg-text-gray);
  font-size: 13px;
}

/* spinner */
.kb-cmp__spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(151, 140, 202, 0.3);
  border-top-color: var(--fg-button);
  border-radius: 50%;
  animation: kb-spin 0.7s linear infinite;
}

@keyframes kb-spin {
  to { transform: rotate(360deg); }
}

/* ========================================================================
   ChunkPreviewModal — 청크 미리보기 모달
   ======================================================================== */

.kb-preview-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: kb-modal-fade 120ms ease-out;
}

@keyframes kb-modal-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.kb-preview-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 760px;
  max-height: calc(100vh - 64px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  animation: kb-modal-pop 160ms ease-out;
}

@keyframes kb-modal-pop {
  from { transform: translateY(8px) scale(0.98); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

/* Head */
.kb-preview-modal__head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--fg-line);
}

.kb-preview-modal__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-preview-modal__title svg {
  color: var(--fg-button);
}

.kb-preview-modal__stats {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--fg-text-gray);
}
.kb-preview-modal__stats b {
  color: var(--fg-text-basic);
  font-weight: 700;
}
.kb-preview-modal__sep {
  color: var(--fg-line);
}

.kb-preview-modal__close {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}
.kb-preview-modal__close:hover {
  background: var(--fg-bg-card);
  color: var(--fg-text-basic);
}

/* Body */
.kb-preview-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
}

.kb-preview-modal__empty {
  margin: 32px 0;
  text-align: center;
  font-size: 13px;
  color: var(--fg-text-gray);
}

/* Chunk list */
.kb-chunk-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kb-chunk {
  position: relative;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  font-size: 13px;
  line-height: 21px;
  color: var(--fg-text-basic);
}

.kb-chunk--alt {
  background: var(--fg-bg-card);
}

.kb-chunk--parent {
  border-color: var(--fg-button);
  background: rgba(151, 140, 202, 0.06);
}

.kb-chunk--child {
  margin-left: 18px;
  border-left: 3px solid var(--fg-button);
}

.kb-chunk__label {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--fg-text-gray);
  text-transform: uppercase;
}

.kb-chunk__badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.kb-chunk__badge--parent {
  background: var(--fg-button);
  color: #fff;
}

.kb-chunk__badge--child {
  background: rgba(151, 140, 202, 0.16);
  color: var(--fg-button-hover);
}

.kb-chunk__text {
  white-space: pre-wrap;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.kb-chunk__text--expanded {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
}

.kb-chunk__toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 10px;
  background: transparent;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-chunk__toggle:hover {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.kb-chunk__toggle-icon--up {
  transform: rotate(180deg);
}

/* Skeleton */
.kb-preview-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.kb-preview-skeleton__item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.kb-preview-skeleton__line {
  height: 10px;
  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: kb-skel 1.4s ease-in-out infinite;
}

.kb-preview-skeleton__line--short { width: 28%; }
.kb-preview-skeleton__line--medium { width: 64%; }

@keyframes kb-skel {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Foot — pagination */
.kb-preview-modal__foot {
  padding: 12px 20px;
  border-top: 1px solid var(--fg-line);
  background: var(--fg-bg-card);
}

.kb-preview-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.kb-preview-pagination__btn,
.kb-preview-pagination__num {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-preview-pagination__btn:hover:not(:disabled),
.kb-preview-pagination__num:hover {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.kb-preview-pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.kb-preview-pagination__num--active {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}
.kb-preview-pagination__num--active:hover {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
  color: #fff;
}

.kb-preview-pagination__gap {
  padding: 0 4px;
  color: var(--fg-text-gray);
}

/* ========================================================================
   KnowledgeUploadDropzone — 모달 내부에 끼우는 컴팩트 업로드 영역
   ======================================================================== */

.kb-upload {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kb-upload__zone {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: var(--fg-bg-content, #f7f5ff);
  border: 1.5px dashed var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
}

.kb-upload__zone:hover,
.kb-upload__zone--drag {
  border-color: var(--fg-button);
  background: rgba(86, 60, 240, 0.05);
}

.kb-upload__input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.kb-upload__icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  color: var(--fg-button);
}

.kb-upload__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kb-upload__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.kb-upload__sub {
  font-size: 11px;
  color: var(--fg-text-gray);
}

.kb-upload__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 140px;
  overflow-y: auto;
}

.kb-upload__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-size: 12px;
}

.kb-upload__item--uploading { color: var(--fg-text-basic); }
.kb-upload__item--ready { color: #0a7c4d; border-color: rgba(16, 185, 129, 0.4); background: rgba(16, 185, 129, 0.06); }
.kb-upload__item--failed { color: var(--fg-anti-red); border-color: rgba(239, 68, 68, 0.4); background: rgba(239, 68, 68, 0.05); }

.kb-upload__item-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kb-upload__item-status {
  flex-shrink: 0;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/css/Knowledge.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;;6EAE6E;;AAE7E,aAAa;AACb;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B,gDAAgD,EAAE;EACjF,wBAAwB,gDAAgD,EAAE;AAC5E;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;;;;6EAI6E;AAC7E;EACE,iCAAiC;EACjC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;yEACuE;EACvE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;wEACsE;EACtE;;IAEE,qCAAqC;IACrC,SAAS;EACX;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA,cAAc,SAAS,EAAE,eAAe,EAAE;;AAE1C,wCAAwC;AACxC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,eAAe,gDAAgD,EAAE;AACnE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB,YAAY,EAAE;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA,wBAAwB,8BAA8B,EAAE;AACxD;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;;AAGA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;AACA,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;AACtD,+BAA+B,8BAA8B,EAAE;;AAE/D;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,cAAc,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACzF,cAAc,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrE,iBAAiB,WAAW,EAAE;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,yBAAyB,0BAA0B,EAAE;AACrD,sBAAsB,2BAA2B,EAAE,gBAAgB,EAAE;;AAErE;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,yFAAyF;EACzF,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA,4BAA4B,uBAAuB,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;;AAGA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kFAAkF;AACpF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;AACA,4BAA4B,aAAa,EAAE,8BAA8B,EAAE;;AAE3E,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,2CAA2C,uBAAuB,EAAE,cAAc,EAAE;AACpF,0CAA0C,iBAAiB,EAAE,cAAc,EAAE,YAAY,EAAE;;AAE3F;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,gBAAgB,EAAE,2BAA2B,EAAE;;AAEvE,UAAU;AACV;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;6EAE6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,OAAO,sCAAsC,EAAE,UAAU,EAAE;EAC3D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,oCAAoC,UAAU,EAAE;AAChD,qCAAqC,UAAU,EAAE;;AAEjD;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,8BAA8B,2BAA2B,EAAE;AAC3D,0BAA0B,cAAc,EAAE,qCAAqC,EAAE,oCAAoC,EAAE;AACvH,2BAA2B,yBAAyB,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;;AAEjI;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* ========================================================================\n   Knowledge — 지식베이스 영역 (Figma 71:5938 외)\n   사이드바·인트로 공통 스타일은 Prompt.css 재사용 (.prompt__sidebar / .prompt-intro__*)\n   ======================================================================== */\n\n/* example 텍스트 줄바꿈 보존 */\n.knowledge-intro__example-pre {\n  white-space: pre-wrap;\n}\n\n/* ───────── 비교 테이블 ───────── */\n.knowledge-intro__vs-table {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  background: var(--fg-bg-card);\n  border-top: 2px solid var(--fg-text-basic);\n}\n\n.knowledge-intro__vs-row {\n  display: contents;\n}\n\n.knowledge-intro__vs-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  background: #fff;\n  border-bottom: 1px solid var(--fg-line);\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  text-align: center;\n}\n\n.knowledge-intro__vs-cell--label {\n  background: #f8f8f8;\n  font-weight: 500;\n}\n\n.knowledge-intro__vs-row--head .knowledge-intro__vs-cell {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.knowledge-intro__vs-cell--head-blue {\n  background: var(--fg-bg-vs-blue);\n}\n\n.knowledge-intro__vs-cell--head-green {\n  background: var(--fg-bg-vs-green);\n}\n\n\n/* ========================================================================\n   KnowledgeList — 지식베이스 관리 (Figma 73:3892)\n   ======================================================================== */\n\n/* 모드 선택 카드 */\n.knowledge-mode__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.knowledge-mode__card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.knowledge-mode__card:hover {\n  border-color: var(--fg-button);\n  box-shadow: var(--shadow-md);\n}\n\n.knowledge-mode__card--clickable {\n  cursor: pointer;\n}\n\n.knowledge-mode__card--clickable:focus-visible {\n  outline: none;\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.25);\n}\n\n.knowledge-mode__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.knowledge-mode__card-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.knowledge-mode__card-summary {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-gray);\n}\n\n.knowledge-mode__feature-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.knowledge-mode__feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.knowledge-mode__feature-list svg {\n  flex-shrink: 0;\n  color: var(--fg-button);\n}\n\n.knowledge-mode__card-usage {\n  margin: 8px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid var(--fg-line);\n  text-align: center;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.knowledge-mode__card-usage b {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  margin-right: 4px;\n}\n\n/* 통계 — 실패 강조 */\n.knowledge-files__stat--failed b {\n  color: var(--fg-anti-red);\n}\n\n/* 선택 설정 드롭다운 */\n.knowledge-files__select-action {\n  position: relative;\n  display: inline-block;\n}\n\n.knowledge-files__select-action .prompt-list__select-action:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.knowledge-files__select-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 160px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  box-shadow: var(--shadow-lg);\n  z-index: 30;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.knowledge-files__select-menu-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n}\n\n.knowledge-files__select-menu-item:hover {\n  background: var(--bg-hover, #f5f5f7);\n}\n\n.knowledge-files__select-menu-item--danger {\n  color: var(--fg-anti-red);\n}\n\n.knowledge-files__select-menu-item--danger:hover {\n  background: rgba(220, 38, 38, 0.08);\n}\n\n/* 전체 선택 — 일부 선택 상태 */\n.prompt-list__bulk-toggle--indeterminate {\n  background: var(--fg-side-hover);\n  opacity: 0.5;\n}\n\n/* 파일 그리드 */\n.knowledge-files__grid {\n  display: grid;\n  gap: 20px;\n}\n\n.knowledge-files__grid--grid {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.knowledge-files__grid--list {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1280px) {\n  .knowledge-files__grid--grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .knowledge-mode__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n/* 모바일 안내 — 기본 숨김, ≤720px 에서만 노출 */\n.knowledge-mode__mobile-note {\n  display: none;\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 파일 리스트 + 간편 업로드만 지원.\n   고급 설정·비교 모드 진입점은 숨기고 한 줄 안내로 대체.\n   레이아웃이 공유 .prompt 라 .knowledge-page 로 스코프해 프롬프트 화면 영향 차단.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 레이아웃: 사이드바(관리 1개뿐) 숨김, 여백 축소 */\n  .knowledge-page .prompt__layout {\n    margin: 0 8px;\n  }\n\n  .knowledge-page .prompt__sidebar {\n    display: none;\n  }\n\n  .knowledge-page .prompt__content {\n    padding: 20px 16px;\n    gap: 28px;\n  }\n\n  .knowledge-page .prompt-intro__h1 {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* 모드 선택: 1열 + 고급/비교 카드 숨김\n     (minmax(0,1fr) — 1fr=minmax(auto,1fr) 이라 긴 내용이 트랙을 밀어 오버플로되는 것 방지) */\n  .knowledge-page .knowledge-mode__grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .knowledge-page .knowledge-mode__card--advanced,\n  .knowledge-page .knowledge-mode__card--compare {\n    display: none;\n  }\n\n  .knowledge-page .knowledge-mode__mobile-note {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 2px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: var(--fg-text-gray);\n  }\n\n  .knowledge-page .knowledge-mode__mobile-note svg {\n    flex-shrink: 0;\n    color: var(--fg-text-gray);\n  }\n\n  /* 파일 리스트: 그리드/리스트 뷰 모두 1열\n     (minmax(0,1fr) 필수 — 긴 파일명(nowrap)이 트랙을 밀어내 ellipsis 대신 잘리는 문제 방지) */\n  .knowledge-page .knowledge-files__grid--grid,\n  .knowledge-page .knowledge-files__grid--list {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  /* 통계 행: 세로 스택 + 업로드 버튼 풀폭 */\n  .knowledge-page .prompt-list__stats-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .knowledge-page .prompt-list__stats {\n    flex-wrap: wrap;\n    gap: 6px 8px;\n  }\n\n  /* 필터 행: 검색이 줄을 가득 채우도록, 그리드/리스트 토글은 숨김(어차피 1열) */\n  .knowledge-page .prompt-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .knowledge-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  .knowledge-page .prompt-list__view-toggle {\n    display: none;\n  }\n\n  /* 간편 업로드: 제목·드롭존 여백 축소 */\n  .knowledge-page .knowledge-upload__title {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  .knowledge-page .knowledge-upload__zone {\n    padding: 28px 16px 32px;\n  }\n}\n\n/* 파일 카드 */\n.knowledge-files__card {\n  display: flex;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.knowledge-files__card:hover {\n  border-color: var(--fg-button);\n}\n\n.knowledge-files__card--selected {\n  border-color: var(--fg-side-hover);\n  box-shadow: 0 0 0 1px var(--fg-side-hover);\n}\n\n.knowledge-files__card-check {\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n\n.knowledge-files__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.knowledge-files__card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.knowledge-files__name {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.knowledge-files__meta {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.knowledge-files__chunks {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n/* 페이지네이션 */\n.knowledge-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 24px 0 8px;\n}\n\n.knowledge-pagination__btn,\n.knowledge-pagination__num {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.knowledge-pagination__btn:hover:not(:disabled),\n.knowledge-pagination__num:hover {\n  background: var(--fg-bg-card);\n  border-color: var(--fg-button);\n}\n\n.knowledge-pagination__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.knowledge-pagination__num--active {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n\n.knowledge-pagination__num--active:hover {\n  background: var(--fg-button-hover);\n  color: #fff;\n}\n\n.knowledge-pagination__gap {\n  padding: 0 4px;\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   KnowledgeList — 간편 업로드 화면 (mode === 'simple') — Figma 2010:32983\n   ======================================================================== */\n\n.knowledge-upload {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 30px 0;\n}\n\n.knowledge-upload__back {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.knowledge-upload__back:hover {\n  background: var(--fg-bg-card);\n}\n\n.knowledge-upload__head {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.knowledge-upload__title-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.knowledge-upload__title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic);\n}\n\n.knowledge-upload__info {\n  display: grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.knowledge-upload__desc {\n  margin: 0;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  font-weight: 400;\n}\n\n/* 드롭존 — 흰배경+실선 border, 큰 아이콘 60px */\n.knowledge-upload__zone {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 40px 40px 50px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  outline: none;\n}\n\n.knowledge-upload__zone:hover,\n.knowledge-upload__zone:focus-visible {\n  border-color: var(--fg-button);\n  background: #fff;\n}\n\n.knowledge-upload__zone--drag {\n  border-color: var(--fg-button);\n  background: #f6f3ff;\n}\n\n.knowledge-upload__zone--uploading {\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.knowledge-upload__input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.knowledge-upload__zone-icon {\n  display: grid;\n  place-items: center;\n  width: 60px;\n  height: 60px;\n  margin-bottom: 4px;\n  color: var(--fg-text-basic);\n}\n\n.knowledge-upload__zone-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.knowledge-upload__zone-sub {\n  margin: 0;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  font-weight: 400;\n}\n\n.knowledge-upload__zone-formats {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n/* 진행 리스트 */\n.knowledge-upload__progress-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.knowledge-upload__progress-item {\n  display: grid;\n  grid-template-columns: 40px 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.knowledge-upload__progress-icon {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  background: var(--fg-bg-card);\n  border-radius: 8px;\n  color: var(--fg-button);\n}\n\n.knowledge-upload__progress-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.knowledge-upload__progress-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.knowledge-upload__progress-meta {\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.knowledge-upload__progress-err {\n  color: var(--fg-anti-red);\n}\n\n.knowledge-upload__progress-bar {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  margin-top: 4px;\n  background: var(--fg-bg-card);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.knowledge-upload__progress-fill {\n  height: 100%;\n  background: var(--fg-button);\n  border-radius: 999px;\n  transition: width 160ms ease-out;\n}\n\n.knowledge-upload__progress-fill--ready {\n  background: var(--fg-button);\n}\n\n.knowledge-upload__progress-fill--failed {\n  background: var(--fg-anti-red);\n}\n\n.knowledge-upload__progress-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.knowledge-upload__progress-status--uploading {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-gray);\n}\n\n.knowledge-upload__progress-status--ready {\n  background: rgba(151, 140, 202, 0.16);\n  color: var(--fg-button-hover);\n}\n\n.knowledge-upload__progress-status--failed {\n  background: rgba(255, 21, 0, 0.1);\n  color: var(--fg-anti-red);\n}\n\n/* ========================================================================\n   AdvancedSetupView — 고급 설정 (4-step) — Figma 2010:32954\n   ======================================================================== */\n\n.kb-advanced {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* 헤더 */\n.kb-advanced__header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.kb-advanced__back {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-advanced__back:hover {\n  background: var(--fg-bg-card);\n}\n\n.kb-advanced__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kb-advanced__title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.kb-advanced__info {\n  display: grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n/* Stepper — pill 컨테이너 + 시안 numbering — Figma 2010:32997 */\n.kb-stepper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0;\n}\n\n.kb-stepper__row {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.kb-stepper__step {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 20px 8px 8px;\n  background: var(--fg-bg-stepper-inactive);\n  border-radius: 50px;\n  transition: var(--transition-fast);\n}\n\n.kb-stepper__step--active {\n  background: var(--fg-bg-liteblue);\n}\n\n.kb-stepper__step--done {\n  background: var(--fg-bg-liteblue);\n}\n\n.kb-stepper__circle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 46px;\n  height: 46px;\n  padding: 0 12px;\n  border-radius: 23px;\n  background: var(--fg-numbering-bg);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 20px;\n  font-weight: 900;\n  line-height: 26px;\n  flex-shrink: 0;\n}\n\n.kb-stepper__step--active .kb-stepper__circle {\n  background: var(--fg-numbering-bg-current);\n  color: #fff;\n}\n\n.kb-stepper__step--done .kb-stepper__circle {\n  background: var(--fg-numbering-bg-current);\n  color: #fff;\n}\n\n.kb-stepper__label {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n}\n\n.kb-stepper__step--active .kb-stepper__label {\n  color: var(--fg-text-basic);\n}\n\n.kb-stepper__step--done .kb-stepper__label {\n  color: var(--fg-text-basic);\n}\n\n.kb-stepper__line {\n  width: 20px;\n  height: 1px;\n  background: var(--fg-line);\n}\n\n.kb-stepper__line--active {\n  background: var(--fg-numbering-bg-current);\n}\n\n/* Step content (no extra card) */\n.kb-step {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.kb-step__head {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kb-step__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.kb-step__desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-gray);\n}\n\n/* Step Card (legacy / preview list 등 호환용 컨테이너) */\n.kb-step-card {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 24px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 14px;\n}\n\n.kb-step-card__head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kb-step-card__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-step-card__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n/* Empty */\n.kb-empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--fg-text-gray);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n.kb-empty p { margin: 0; font-size: 14px; }\n\n/* Document grid (Step 1) — 3-col grid */\n.kb-doc-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n@media (max-width: 1280px) {\n  .kb-doc-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n.kb-doc-card {\n  display: block;\n  padding: 16px 20px;\n  min-height: 80px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-doc-card:hover {\n  border-color: var(--fg-button);\n}\n\n.kb-doc-card--selected {\n  border-color: var(--fg-button);\n  background: rgba(151, 140, 202, 0.06);\n}\n\n.kb-doc-card--disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.kb-doc-card--disabled:hover {\n  border-color: var(--fg-line);\n}\n\n.kb-doc-card__info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kb-doc-card__name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kb-doc-card__meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n.kb-doc-card__meta-divider {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: var(--fg-line);\n}\n\n/* Step 1 actions row (left + right group) */\n.kb-step-actions__group {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* legacy doc-list (호환용 — 미사용 시 제거 가능) */\n.kb-doc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kb-doc-item {\n  display: grid;\n  grid-template-columns: 22px 1fr;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-doc-item:hover {\n  border-color: var(--fg-button);\n}\n\n.kb-doc-item--selected {\n  border-color: var(--fg-button);\n  background: rgba(151, 140, 202, 0.06);\n}\n\n.kb-doc-item--disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.kb-doc-item--disabled:hover {\n  border-color: var(--fg-line);\n}\n\n.kb-doc-item__info { min-width: 0; }\n.kb-doc-item__name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 상태 뱃지 */\n.kb-doc-badge {\n  flex-shrink: 0;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n.kb-doc-badge--completed,\n.kb-doc-badge--ready {\n  background: rgba(151, 140, 202, 0.16);\n  color: var(--fg-button-hover);\n}\n.kb-doc-badge--uploading,\n.kb-doc-badge--processing,\n.kb-doc-badge--pending {\n  background: rgba(255, 178, 38, 0.14);\n  color: #b07700;\n}\n.kb-doc-badge--failed {\n  background: rgba(255, 21, 0, 0.1);\n  color: var(--fg-anti-red);\n}\n\n/* 빈 상태 보조 텍스트 */\n.kb-empty__hint {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n.kb-doc-item__meta {\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n/* Radio */\n.kb-radio {\n  display: grid;\n  place-items: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1.5px solid var(--fg-line);\n}\n.kb-radio--selected {\n  border-color: var(--fg-button);\n}\n.kb-radio__dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--fg-button);\n}\n\n.kb-show-more {\n  align-self: flex-start;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px dashed var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n.kb-show-more:hover {\n  color: var(--fg-text-basic);\n  border-color: var(--fg-button);\n}\n\n/* Option cards (Step 2/3) — 큰 풀폭 카드 */\n.kb-option-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n\n.kb-option-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 18px 22px;\n  min-height: 85px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-option-card:hover { border-color: var(--fg-button); }\n.kb-option-card--active {\n  border-color: var(--fg-button);\n  background: rgba(151, 140, 202, 0.06);\n  box-shadow: 0 0 0 1px var(--fg-button);\n}\n\n.kb-option-card__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.kb-option-card__icon {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  background: var(--fg-bg-card);\n  border-radius: 6px;\n  color: var(--fg-button);\n  flex-shrink: 0;\n}\n\n.kb-option-card__title {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-option-card__badge {\n  padding: 2px 10px;\n  background: var(--fg-button);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.kb-option-card__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n/* Form */\n.kb-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.kb-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.kb-form-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n\n.kb-section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* 리랭크 토글 박스 */\n.kb-toggle-box {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 18px 22px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.kb-toggle-box--active {\n  border-color: var(--fg-button);\n  background: rgba(151, 140, 202, 0.04);\n}\n\n.kb-toggle-box__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.kb-toggle-box__title-group {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kb-toggle-box__title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-toggle-box__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n/* 토글 스위치 */\n.kb-switch {\n  position: relative;\n  display: inline-flex;\n  width: 36px;\n  height: 20px;\n  background: var(--fg-line);\n  border: 0;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.kb-switch__thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 160ms ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n\n.kb-switch--on {\n  background: var(--fg-button);\n}\n\n.kb-switch--on .kb-switch__thumb {\n  transform: translateX(16px);\n}\n\n.kb-form-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n.kb-form-label__hint {\n  margin-left: 4px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n.kb-form-hint {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.kb-form-input,\n.kb-form-select,\n.kb-form-textarea {\n  width: 100%;\n  padding: 9px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.kb-form-input--narrow {\n  max-width: 160px;\n}\n\n.kb-form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.kb-form-input:focus,\n.kb-form-select:focus,\n.kb-form-textarea:focus {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);\n}\n\n/* Slider — horizontal: label - track - value */\n.kb-slider-row {\n  display: grid;\n  grid-template-columns: 220px 1fr 60px;\n  align-items: center;\n  gap: 24px;\n  padding: 4px 0;\n}\n\n\n.kb-slider-row__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.kb-slider-row__label-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-slider-row__hint {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.kb-slider-row__value {\n  text-align: right;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* legacy slider container — used in existing code */\n.kb-slider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.kb-slider__input {\n  flex: 1;\n  height: 4px;\n  appearance: none;\n  background: var(--fg-bg-card);\n  border-radius: 999px;\n  outline: none;\n}\n\n.kb-slider__input::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: var(--fg-button);\n  border: 2px solid #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);\n}\n.kb-slider__input::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: var(--fg-button);\n  border: 2px solid #fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.kb-slider__value {\n  min-width: 56px;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* Buttons — Figma 2010:33033 / 33037 / 33038 (rounded 12px, Bold 16px) */\n.kb-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n.kb-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.kb-btn:hover:not(:disabled) { border-color: var(--fg-button); }\n\n.kb-btn svg {\n  flex-shrink: 0;\n}\n\n/* \"이전 / 취소\" 등 보조 버튼 — gray solid */\n.kb-btn--ghost {\n  background: var(--fg-text-gray);\n  border-color: var(--fg-text-gray);\n  color: #fff;\n}\n.kb-btn--ghost:hover:not(:disabled) {\n  background: #5a5a5a;\n  border-color: #5a5a5a;\n  color: #fff;\n}\n\n.kb-btn--outline {\n  background: #fff;\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n.kb-btn--outline:hover:not(:disabled) {\n  background: rgba(151, 140, 202, 0.08);\n  border-color: var(--fg-button);\n}\n\n.kb-btn--primary {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n.kb-btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n}\n\n.kb-btn--sm { min-height: 36px; padding: 6px 12px; font-size: 14px; border-radius: 10px; }\n.kb-btn--lg { min-height: 48px; padding: 12px 24px; font-size: 16px; }\n.kb-btn--block { width: 100%; }\n\n.kb-step-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding-top: 16px;\n}\n\n/* Preview list */\n.kb-preview-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: var(--fg-bg-card);\n  border-radius: 10px;\n}\n.kb-preview-list__item {\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n.kb-preview-list__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-button);\n}\n.kb-preview-list__text {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n}\n\n/* Summary section (Step 4) — section title + bordered rows */\n.kb-summary-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.kb-summary-section__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-summary-rows {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.kb-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--fg-line);\n  font-size: 14px;\n}\n\n.kb-summary-row:last-child {\n  border-bottom: 0;\n}\n\n.kb-summary-row > span {\n  color: var(--fg-text-gray);\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.kb-summary-row > b {\n  color: var(--fg-text-basic);\n  font-weight: 500;\n  text-align: right;\n  word-break: break-all;\n}\n\n/* Summary cards (legacy 호환) */\n.kb-summary {\n  padding: 16px 18px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.kb-summary__title {\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-summary__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.kb-summary__list li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n\n.kb-summary__list span { color: var(--fg-text-gray); }\n.kb-summary__list b { color: var(--fg-text-basic); font-weight: 600; }\n\n/* ========================================================================\n   CompareModeView — 비교 모드 (Figma 2010:33309)\n   ======================================================================== */\n\n.kb-cmp {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 30px 0;\n}\n\n/* 페이지 헤더 */\n.kb-cmp__back {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n.kb-cmp__back:hover {\n  background: var(--fg-bg-card);\n}\n\n.kb-cmp__page-title-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.kb-cmp__page-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__page-info {\n  display: grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.kb-cmp__page-desc {\n  margin: 0;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  font-weight: 400;\n}\n\n/* 모델 선택 (페이지 우측 상단) */\n.kb-cmp__model-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.kb-cmp__model-select {\n  min-width: 291px;\n  height: 36px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n.kb-cmp__model-select:focus {\n  outline: none;\n  border-color: var(--fg-button);\n}\n\n/* 모델 트리거 버튼 (popover anchor) */\n.kb-cmp__model-anchor {\n  position: relative;\n  display: inline-flex;\n}\n\n.kb-cmp__model-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 291px;\n  height: 36px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__model-trigger:hover {\n  border-color: var(--fg-button);\n}\n\n.kb-cmp__model-trigger[aria-expanded='true'] {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);\n}\n\n.kb-cmp__model-trigger-prefix {\n  color: var(--fg-text-gray);\n  font-weight: 400;\n  flex-shrink: 0;\n}\n\n.kb-cmp__model-trigger-name {\n  flex: 1;\n  text-align: left;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kb-cmp__model-trigger-placeholder-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: var(--fg-bg-card);\n  border-radius: 4px;\n}\n\n.kb-cmp__model-trigger > svg:last-child {\n  color: var(--fg-text-gray);\n  flex-shrink: 0;\n}\n\n/* ── 통합 쿼리 바 ── */\n.kb-cmp__query {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px 22px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 14px;\n}\n\n.kb-cmp__query-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.kb-cmp__query-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.kb-cmp__query-title {\n  margin: 0 0 4px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__query-desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__query-model {\n  min-width: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kb-cmp__query-input {\n  width: 100%;\n  padding: 12px 14px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  resize: vertical;\n  min-height: 80px;\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__query-input:focus {\n  background: #fff;\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);\n}\n\n.kb-cmp__query-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.kb-cmp__query-actions-left {\n  display: inline-flex;\n  gap: 6px;\n}\n\n/* ── 비교 인사이트 ── */\n.kb-cmp__insights {\n  padding: 14px 18px;\n  background: linear-gradient(180deg, rgba(151, 140, 202, 0.08), rgba(151, 140, 202, 0.02));\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.kb-cmp__insights-title {\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--fg-button-hover);\n}\n\n.kb-cmp__insights-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n\n.kb-cmp__insight-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.kb-cmp__insight-head {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__insight-head svg { color: var(--fg-button); }\n\n.kb-cmp__insight-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__insight-val {\n  font-weight: 600;\n}\n\n.kb-cmp__delta {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.kb-cmp__delta--a-better {\n  background: rgba(34, 197, 94, 0.12);\n  color: #137a3a;\n}\n.kb-cmp__delta--b-better {\n  background: rgba(255, 21, 0, 0.1);\n  color: var(--fg-anti-red);\n}\n.kb-cmp__delta--same {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-gray);\n}\n\n/* ── 패널 그리드 ── */\n.kb-cmp__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n\n/* ── 패널 (Frame 484/485) ── */\n.kb-cmp__panel {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 16px;\n  box-shadow: 0 7px 9px 2px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.kb-cmp__panel--running {\n  border-color: var(--fg-button);\n  box-shadow: 0 7px 9px 2px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(151, 140, 202, 0.12);\n}\n\n/* 패널 헤더 (48px, light bg) */\n.kb-cmp__panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  padding: 8px 16px;\n  background: var(--fg-bg-toolbar);\n}\n\n.kb-cmp__panel-head-left {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* A/B 둥근 라벨 (28x28) */\n.kb-cmp__panel-badge {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.kb-cmp__panel-badge--a {\n  background: var(--fg-button-hover);\n}\n\n.kb-cmp__panel-badge--b {\n  background: var(--fg-class-green);\n}\n\n.kb-cmp__panel-name {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n/* 헤더 우측 toolbar 버튼 (refresh) */\n.kb-cmp__panel-refresh {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 32px;\n  background: var(--fg-bg-litepp);\n  border: 0;\n  border-radius: 4px;\n  color: var(--fg-button-hover);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__panel-refresh:hover {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n/* 패널 본문 */\n.kb-cmp__panel-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n\n/* 모드 선택 카드 3개 */\n.kb-cmp__mode-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.kb-cmp__mode-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: center;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__mode-card:hover {\n  border-color: var(--fg-text-basic);\n}\n\n.kb-cmp__mode-card--active {\n  background: #fff;\n  border-color: var(--fg-text-basic);\n  border-width: 1px;\n  box-shadow: inset 0 0 0 1px var(--fg-text-basic);\n}\n\n.kb-cmp__mode-card__icon {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__mode-card--active .kb-cmp__mode-card__icon {\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__mode-card__title {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__mode-card--active .kb-cmp__mode-card__title {\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__mode-card__desc {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n/* 문서 선택 (full width dropdown) */\n.kb-cmp__doc-select-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kb-cmp__doc-select-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__doc-select {\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n.kb-cmp__doc-select:focus { outline: none; border-color: var(--fg-button); }\n\n/* 모드 안내 영역 */\n.kb-cmp__panel-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kb-cmp__panel-info-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__panel-info-desc {\n  margin: 0;\n  font-size: 15px;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n/* B 패널 동기화 힌트 */\n.kb-cmp__sync-hint {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-button);\n}\n\n/* 채팅 입력 박스 */\n.kb-cmp__chat-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #fff;\n  border-radius: 30px;\n  box-shadow: 0 2px 3.35px rgba(0, 0, 0, 0.2);\n}\n\n.kb-cmp__chat-input__field {\n  flex: 1;\n  min-width: 0;\n  height: 26px;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  outline: none;\n}\n\n.kb-cmp__chat-input__field::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__chat-input__send {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.kb-cmp__chat-input__send:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.kb-cmp__chat-input__send:disabled {\n  background: var(--fg-line);\n  cursor: not-allowed;\n}\n\n/* 응답 박스 (AI 응답) */\n.kb-cmp__response {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.kb-cmp__response-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.kb-cmp__response-head-left {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kb-cmp__response-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #000;\n}\n\n.kb-cmp__response-model {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  background: var(--fg-bg-litepp);\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #000;\n}\n\n.kb-cmp__response-stats {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kb-cmp__response-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__response-stat-label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.kb-cmp__response-stat-value {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.kb-cmp__response-stat-divider {\n  display: inline-block;\n  width: 1px;\n  height: 22px;\n  background: var(--fg-line);\n}\n\n.kb-cmp__response-body {\n  margin: 0;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.kb-cmp__response-empty {\n  margin: 0;\n  font-size: 15px;\n  color: var(--fg-text-gray);\n  font-style: italic;\n}\n\n.kb-cmp__response-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--fg-text-gray);\n  font-size: 14px;\n}\n\n/* legacy 비교 panel-tag (사용 안 함) */\n.kb-cmp__panel-tag {\n  padding: 4px 10px;\n  background: var(--fg-button);\n  color: #fff;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n/* 모드 세그먼트 */\n.kb-cmp__seg {\n  display: inline-flex;\n  background: var(--fg-bg-card);\n  border-radius: 8px;\n  padding: 2px;\n}\n\n.kb-cmp__seg-btn {\n  padding: 6px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__seg-btn--active {\n  background: #fff;\n  color: var(--fg-text-basic);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n/* 패널 설정 영역 */\n.kb-cmp__panel-config {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* 문서 선택 inline trigger */\n.kb-cmp__doc {\n  position: relative;\n}\n\n.kb-cmp__doc-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 12px;\n  background: var(--fg-bg-card);\n  border: 1px dashed var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__doc-trigger:hover {\n  border-color: var(--fg-button);\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__doc-trigger--filled {\n  background: #fff;\n  border-style: solid;\n  border-color: var(--fg-button);\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__doc-trigger > svg:first-of-type { color: var(--fg-button); flex-shrink: 0; }\n.kb-cmp__doc-trigger > svg:last-of-type { margin-left: auto; flex-shrink: 0; opacity: 0.6; }\n\n.kb-cmp__doc-text {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n}\n\n.kb-cmp__doc-tag {\n  flex-shrink: 0;\n  padding: 1px 6px;\n  background: rgba(151, 140, 202, 0.16);\n  color: var(--fg-button-hover);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.kb-cmp__doc-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 4;\n}\n\n.kb-cmp__doc-pop {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  box-shadow: var(--shadow-lg);\n  max-height: 320px;\n  overflow: hidden;\n}\n\n.kb-cmp__doc-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  max-height: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kb-cmp__doc-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__doc-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.kb-cmp__doc-item--selected {\n  background: rgba(151, 140, 202, 0.1);\n}\n\n.kb-cmp__doc-item-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kb-cmp__doc-item-meta {\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__doc-empty {\n  padding: 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n/* 고급 옵션 토글 */\n.kb-cmp__opts-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  background: transparent;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-cmp__opts-toggle:hover {\n  background: var(--fg-bg-card);\n}\n\n.kb-cmp__opts-toggle--open svg:last-child {\n  transform: rotate(180deg);\n}\n\n.kb-cmp__opts-toggle svg:last-child {\n  transition: transform 160ms ease;\n  margin-left: 0;\n}\n\n.kb-cmp__opts-summary {\n  margin-left: auto;\n  margin-right: 4px;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  font-weight: 500;\n}\n\n.kb-cmp__opts {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px;\n  background: var(--fg-bg-card);\n  border-radius: 10px;\n}\n\n.kb-cmp__slider {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.kb-cmp__slider-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n}\n\n.kb-cmp__slider-label { color: var(--fg-text-gray); }\n.kb-cmp__slider-value { font-weight: 600; color: var(--fg-text-basic); }\n\n/* 결과 영역 */\n.kb-cmp__panel-result {\n  flex: 1;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.kb-cmp__result-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.kb-cmp__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-cmp__chip svg {\n  color: var(--fg-button);\n}\n\n.kb-cmp__result-body {\n  flex: 1;\n  font-size: 13px;\n  line-height: 21px;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-y: auto;\n  max-height: 360px;\n}\n\n.kb-cmp__result-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--fg-text-gray);\n}\n\n.kb-cmp__result-empty p {\n  margin: 0;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.kb-cmp__result-loading {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--fg-text-gray);\n  font-size: 13px;\n}\n\n/* spinner */\n.kb-cmp__spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(151, 140, 202, 0.3);\n  border-top-color: var(--fg-button);\n  border-radius: 50%;\n  animation: kb-spin 0.7s linear infinite;\n}\n\n@keyframes kb-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ========================================================================\n   ChunkPreviewModal — 청크 미리보기 모달\n   ======================================================================== */\n\n.kb-preview-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: kb-modal-fade 120ms ease-out;\n}\n\n@keyframes kb-modal-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.kb-preview-modal {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 760px;\n  max-height: calc(100vh - 64px);\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n  animation: kb-modal-pop 160ms ease-out;\n}\n\n@keyframes kb-modal-pop {\n  from { transform: translateY(8px) scale(0.98); opacity: 0; }\n  to { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n/* Head */\n.kb-preview-modal__head {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 20px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.kb-preview-modal__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-preview-modal__title svg {\n  color: var(--fg-button);\n}\n\n.kb-preview-modal__stats {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n.kb-preview-modal__stats b {\n  color: var(--fg-text-basic);\n  font-weight: 700;\n}\n.kb-preview-modal__sep {\n  color: var(--fg-line);\n}\n\n.kb-preview-modal__close {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n.kb-preview-modal__close:hover {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-basic);\n}\n\n/* Body */\n.kb-preview-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n.kb-preview-modal__empty {\n  margin: 32px 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n/* Chunk list */\n.kb-chunk-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.kb-chunk {\n  position: relative;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  font-size: 13px;\n  line-height: 21px;\n  color: var(--fg-text-basic);\n}\n\n.kb-chunk--alt {\n  background: var(--fg-bg-card);\n}\n\n.kb-chunk--parent {\n  border-color: var(--fg-button);\n  background: rgba(151, 140, 202, 0.06);\n}\n\n.kb-chunk--child {\n  margin-left: 18px;\n  border-left: 3px solid var(--fg-button);\n}\n\n.kb-chunk__label {\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--fg-text-gray);\n  text-transform: uppercase;\n}\n\n.kb-chunk__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.kb-chunk__badge--parent {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.kb-chunk__badge--child {\n  background: rgba(151, 140, 202, 0.16);\n  color: var(--fg-button-hover);\n}\n\n.kb-chunk__text {\n  white-space: pre-wrap;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.kb-chunk__text--expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n}\n\n.kb-chunk__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  padding: 4px 10px;\n  background: transparent;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-chunk__toggle:hover {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.kb-chunk__toggle-icon--up {\n  transform: rotate(180deg);\n}\n\n/* Skeleton */\n.kb-preview-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.kb-preview-skeleton__item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.kb-preview-skeleton__line {\n  height: 10px;\n  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  animation: kb-skel 1.4s ease-in-out infinite;\n}\n\n.kb-preview-skeleton__line--short { width: 28%; }\n.kb-preview-skeleton__line--medium { width: 64%; }\n\n@keyframes kb-skel {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Foot — pagination */\n.kb-preview-modal__foot {\n  padding: 12px 20px;\n  border-top: 1px solid var(--fg-line);\n  background: var(--fg-bg-card);\n}\n\n.kb-preview-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.kb-preview-pagination__btn,\n.kb-preview-pagination__num {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-preview-pagination__btn:hover:not(:disabled),\n.kb-preview-pagination__num:hover {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.kb-preview-pagination__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.kb-preview-pagination__num--active {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n.kb-preview-pagination__num--active:hover {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n  color: #fff;\n}\n\n.kb-preview-pagination__gap {\n  padding: 0 4px;\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   KnowledgeUploadDropzone — 모달 내부에 끼우는 컴팩트 업로드 영역\n   ======================================================================== */\n\n.kb-upload {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kb-upload__zone {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  background: var(--fg-bg-content, #f7f5ff);\n  border: 1.5px dashed var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.kb-upload__zone:hover,\n.kb-upload__zone--drag {\n  border-color: var(--fg-button);\n  background: rgba(86, 60, 240, 0.05);\n}\n\n.kb-upload__input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.kb-upload__icon {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  color: var(--fg-button);\n}\n\n.kb-upload__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kb-upload__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.kb-upload__sub {\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n.kb-upload__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 140px;\n  overflow-y: auto;\n}\n\n.kb-upload__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.kb-upload__item--uploading { color: var(--fg-text-basic); }\n.kb-upload__item--ready { color: #0a7c4d; border-color: rgba(16, 185, 129, 0.4); background: rgba(16, 185, 129, 0.06); }\n.kb-upload__item--failed { color: var(--fg-anti-red); border-color: rgba(239, 68, 68, 0.4); background: rgba(239, 68, 68, 0.05); }\n\n.kb-upload__item-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kb-upload__item-status {\n  flex-shrink: 0;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
